<div class="copyright-text">
    &copy; {{currentYear}} 
    <span class="copyright-text-company" *ngIf="shouldShowFull" @fade>
        <b><a href="http://www.winstonbenefits.com/" target="_blank">Winston</a></b>. All Rights Reserved.
    </span>
</div>